/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */


import { createSlice } from "@reduxjs/toolkit";
import { updateSearchKeywordAction, resetSearchKeywordAction, updatePageAction, updateSearchKeywordForScopeAction, resetSearchKeywordForScopeAction } from "./actions";
import { ISearchState } from "./type";

const initialState: ISearchState = { searchedKeyword: "", page: "", scopedKeywords: {} };

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    updateKeyword: updateSearchKeywordAction,
    resetKeyword: resetSearchKeywordAction,
    updatePage : updatePageAction,
    updateKeywordForScope: updateSearchKeywordForScopeAction,
    resetKeywordForScope: resetSearchKeywordForScopeAction,
  },
});

export const { updateKeyword,resetKeyword,updatePage, updateKeywordForScope, resetKeywordForScope,
} = searchSlice.actions;

export const searchReducer = searchSlice.reducer;